import { css } from '@mui/material/styles';
export const tableComponentOverrides = {
    MuiTableContainer: {
        styleOverrides: {
            root: ({ theme }) => ({
                '&.MuiPaper-root': {
                    '& tbody tr:last-child td, & tbody tr:last-child th': {
                        border: 0
                    }
                },
                '&[data-fuel-outlined=true]': {
                    border: `1px solid ${theme.tokens.FuelColorBorderLight}`,
                    borderRadius: theme.tokens.FuelBorderRadiusLg
                }
            })
        }
    },
    MuiTable: {
        styleOverrides: {
            root: ({ theme }) => ({
                '&[data-fuel-striped=true] .MuiTableBody-root .MuiTableRow-root:nth-of-type(2n)': {
                    backgroundColor: theme.tokens.FuelColorGray100,
                    '&:hover': {
                        backgroundColor: theme.tokens.FuelColorGray50
                    }
                }
            }),
            stickyHeader: {
                borderCollapse: 'collapse'
            }
        }
    },
    MuiTableCell: {
        styleOverrides: {
            root: ({ theme }) => ({
                borderBottom: `1px solid ${theme.tokens.FuelColorBorderLight}`
            }),
            stickyHeader: ({ theme }) => ({
                backgroundColor: theme.tokens.FuelColorWhite,
                borderBottom: `1px solid ${theme.tokens.FuelColorBorderLight}`,
                borderCollapse: 'collapse'
            }),
            sizeSmall: ({ theme }) => ({
                padding: `0.375rem ${theme.tokens.FuelSpacing4}`
            })
        }
    },
    MuiTablePagination: {
        defaultProps: {
            component: 'div',
            slotProps: {
                select: {
                    variant: 'outlined'
                }
            }
        },
        styleOverrides: {
            toolbar: css `
                .MuiInputBase-root.MuiTablePagination-input {
                    margin-inline: 0.5rem 2rem;
                }
            `
        }
    },
    MuiTableRow: {
        styleOverrides: {
            root: ({ theme }) => ({
                borderBottom: `1px solid ${theme.tokens.FuelColorBorderLight}`,
                '&:last-child': {
                    border: 0
                }
            })
        }
    }
};
